import { render } from "./PrintedVertical.vue?vue&type=template&id=f4c4c39a&scoped=true"
import script from "./PrintedVertical.vue?vue&type=script&lang=js"
export * from "./PrintedVertical.vue?vue&type=script&lang=js"

import "./PrintedVertical.vue?vue&type=style&index=0&id=f4c4c39a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f4c4c39a"

export default script